module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#android-block",
      toString: function () {
        return this.url;
      }
    }